
export default function Investors() {
  const highlights = [
    {
      icon: 'ri-funds-line',
      title: 'Self-Funded Stage',
      description: 'Initial capital allocated toward product design, market analysis, and prototype development.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Bootstrap Approach',
      description: 'Greater control over product vision and strategic direction during early stages.',
    },
    {
      icon: 'ri-seedling-line',
      title: 'Growth Ready',
      description: 'Exploring angel investment and grants focused on sustainable urban innovation.',
    },
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="investors" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center bg-amber-100 rounded-full px-4 py-2 mb-6">
              <i className="ri-hand-coin-line text-amber-600 mr-2 w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-amber-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                Investment Opportunity
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Investors Welcome
            </h2>
            <p className="text-base text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              We're building the future of urban mobility in Malaysia. As we progress toward our Q3 2026 launch, we're open to strategic partnerships and investment opportunities that align with our vision for sustainable transportation.
            </p>

            <div className="space-y-4 mb-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-10 h-10 bg-teal-50 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className={`${item.icon} text-lg text-teal-600 w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={scrollToContact}
              className="inline-flex items-center px-8 py-4 bg-teal-600 text-white rounded-full text-sm font-medium hover:bg-teal-700 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Discuss Investment
              <i className="ri-arrow-right-line ml-2 text-lg w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
            <h3 className="text-lg font-bold text-gray-900 mb-6" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Why Invest With Us
            </h3>
            <div className="space-y-4">
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-100">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Growing market demand in Kuala Lumpur
                </span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-100">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Experienced leadership team with proven track record
                </span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-100">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Cutting-edge AI technology differentiation
                </span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-100">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                  CSR-focused minimal fee model for mass adoption
                </span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg border border-gray-100">
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-600 w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="text-sm text-gray-700" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Aligned with Malaysia's smart city initiatives
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
